<template>
    <svg class="icon-svg" :class="cssClass">
        <use class="symbol__use" :xlink:href="`#icon-svg-${name}`"></use>
    </svg>
</template>

<script>
export default {
    name: 'svg-symbol',
}
</script>

<script setup>
import componentProps from './svg-symbol.props';
defineProps(componentProps)
</script>